/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TargetArrow from './target-arrow-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TargetArrow {...validProps} />;
}
SvgComponent.iconName = 'targetArrow';

export const TargetArrowIcon = svgIconWrapper(SvgComponent);
